import { useEffect, useState } from 'react';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetProgrammeOverviewsQuery } from '../../redux/programmeApiV2';
import {
  getJourneyAndProgrammeIds,
  getProgrammeOverviewBySlug,
} from '../../utils/JourneyUtils';

export const useCurrentProgrammeOverview = (
  profileQuery,
  programmeSlug,
  forceRefetch = false
) => {
  const [overviewsRequest, setOverviewsRequest] = useState(null);
  const [overview, setOverview] = useState(null);

  const {
    data: programmeOverviews,
    isSuccess,
    isUninitialized,
    refetch,
  } = useGetProgrammeOverviewsQuery(overviewsRequest ?? skipToken);

  useEffect(() => {
    if (!profileQuery?.isSuccess || profileQuery?.isUninitialized) {
      return;
    }

    setOverviewsRequest({
      profileId: profileQuery.data.userId,
      programmeAndJourneyIds: getJourneyAndProgrammeIds(profileQuery?.data),
    });
  }, [profileQuery]);

  useEffect(() => {
    if (!isSuccess || isUninitialized) {
      return;
    }

    if (forceRefetch) {
      refetch();
    }

    const currentProgrammeOverview = getProgrammeOverviewBySlug(
      programmeOverviews,
      programmeSlug
    );
    setOverview(currentProgrammeOverview);
  }, [
    forceRefetch,
    isSuccess,
    isUninitialized,
    programmeOverviews,
    programmeSlug,
    refetch,
  ]);

  return overview;
};
